import en from './entries/en';
import zh from './entries/zh';
import it from './entries/it';
import es from './entries/es';
import ca from './entries/ca';
import de from './entries/de';
import fr from './entries/fr';
import { addLocaleData } from 'react-intl';

import {getCustomerConfig} from '../utils/SettingsRetriever';

const AppLocale = {
  en: en,
  zh: zh,
  it: it,
  es: es,
  ca: ca,
  de: de,
  fr: fr
};

const config = getCustomerConfig();
const langs = config.config.langs;
if (langs) {
  Object.keys(langs).forEach((val, idx) => {
    const customLang = langs[val];
    const lang = AppLocale[val].messages;
    const reusltLang = Object.assign(lang, customLang);
    AppLocale[val].messages = reusltLang;
  })
}

addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.zh.data);
addLocaleData(AppLocale.it.data);
addLocaleData(AppLocale.es.data);
addLocaleData(AppLocale.ca.data);
addLocaleData(AppLocale.de.data);
addLocaleData(AppLocale.fr.data);

export default AppLocale;